import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useIntl } from "react-intl";
import * as actions from "../../../actions/generalActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardFooter,
} from "../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { FilterObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import { AuditFormResultDialog } from "../../../../_metronic/layout/components/basePage/pages/objects-update-status-dialog/AuditFormResultDialog";
import { ObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/ObjectsUIContext";
import { ObjectsLoadingDialog } from "../../../../_metronic/layout/components/basePage/pages/objects-loading-dialog/ObjectsLoadingDialog";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import { NearMe } from "@material-ui/icons";
import {
  ShowToast,
  ToastType,
} from "../../../../_metronic/_helpers/ToastHelpers";
import GolestanSearchDialog from "../../customComponents/GolestanSearchDialog";

export function AuditFormListEditPage({
  basePath,
  isFullAccess,
  api,
  prepareFilter,
  currentState,
  listState,
  columns,
  formFields,
  otherFields,
  ObjectEditSchema,
  otherTabs,
  filterFields,
  filterInitialValues,
  history,
  match: {
    params: { id },
  },
  auditEdit = false,
  methodName,
  updateMethodName,
  rowFormatter,
  exportfuncName,
  isSeatForm = false
}) {
  // Subheader
  const suhbeader = useSubheader();

  const intl = useIntl();
  // Tabs
  const [title1, setTitle1] = useState(" پرسشنامه");
  const [title2, setTitle2] = useState("");
  const [title3, setTitle3] = useState("تعداد کل سوالات :  0");

  const [selectedId, setSelectedId] = useState(null);
  const [show, setShow] = useState(false);
  const [showGolestanSearch, setShowGolestanSearch] = useState(false);
  const [confirmForm, setConfirm] = useState(false);
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { listLoading, entities, name, totalCount } = useSelector(
    (state) => ({
      listLoading: currentState.listLoading,
      entities: currentState.entities,
      totalCount: currentState.totalCount,
      name: currentState.name,
    }),
    shallowEqual
  );

  const ObjectsUIEvents = {
    // newObjectButtonClick: () => {
    //     history.push(`${basePath}/new`);
    // },
    openAnswerDialog: (id) => {
      // history.push(`${basePath}//updateAnswer`);
      setSelectedId(id);
      // if (isSeatForm)
      //   setShowGolestanSearch(true)
      // else
      setShow(true);
    },
  };

  if (columns.find((q) => q.dataField === "action")) {
    columns.pop();
  }
  columns.push({
    dataField: "action",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
    // text: "Actions",
    formatter: columnFormatters.AuditListAnswerColumnFormatter,
    formatExtraData: {
      openAnswerDialog: ObjectsUIEvents.openAnswerDialog,
    },
    // formatter: columnFormatters.AuditActionsColumnFormatter,
    // formatExtraData: {
    //   openEditObjectPage: objectsUIProps.openEditObjectPage
    // },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    },
  });

  const init = {
    whereClause: "",
    whereClauseParameters: [],
    orderClause: "id asc ",
    skipCount: 0,
    takeCount: 1000,
  };
  const [localQuery, setLocalQuery] = useState(init);

  useEffect(() => {
    dispatch(actions.fetchObjectsById(api, name, id, localQuery, methodName));
  }, [localQuery, dispatch, id]);

  useEffect(() => {
    dispatch(actions.fetchObject("api/AuditFormList", listState.name, id));
  }, [id]);

  useEffect(() => {
    var _title1 = " پرسشنامه ";
    var _title2 = "";
    var _title3 = "";

    if (listState.objectForEdit) {
      _title1 = " پرسشنامه   " + listState.objectForEdit.auditFormTypeTitle;
    }

    if (listState.objectForEdit) {
      _title2 = listState.objectForEdit.title;
    }

    if (entities) {
      var countNot = entities.filter(
        (q) => q.enteredAnswer === null || q.enteredAnswer === ""
      ).length;
      var countYes = entities.filter(
        (q) => q.enteredAnswer || q.enteredAnswer !== ""
      ).length;
      _title3 =
        "     " +
        "تعداد کل سوالات :  " +
        totalCount +
        "  -  تعداد سوالات پاسخ نداده :  " +
        countNot +
        "  -  تعداد سوالات پاسخ داده :  " +
        countYes;
    }

    setTitle1(_title1);
    setTitle2(_title2);
    setTitle3(_title3);
    // suhbeader.setTitle(_title);
  }, [listState.objectForEdit, entities]);

  const handleClickExport = () => {

    var query = { id: id }
    dispatch(
      actions.downloadExcelFile(
        api,
        name,
        query,
        exportfuncName
      )
    );
  };

  const saveObjectClick = () => {
    if (entities && id) {
      var countYes = entities.filter(
        (q) => q.enteredAnswer || q.enteredAnswer !== ""
      ).length;
      if (countYes !== totalCount) {
        ShowToast(
          "تا زمانیکه تمام پرسش های پرسشنامه را تکمیل نکنید قادر به تایید نهایی تکمیل پرسشنامه نیستید.",
          ToastType.error,
          15000
        );
        return;
      } else {
        var ids = entities.map((a) => a.id);
        dispatch(
          actions.updateObjectsResultStatus(
            api,
            name,
            +id,
            ids,
            "Completed",
            updateMethodName
          )
        ).then(() => backToObjectsList());
      }
    }
  };

  const backToObjectsList = () => {
    dispatch(
      actions.fetchObjectsById(api, name, undefined, localQuery, methodName)
    );
    history.push(basePath);
  };

  const handleEnableEditForm = () => {
    if (listState.objectForEdit && listState.objectForEdit.id) {
      const formId = listState.objectForEdit.id;
      dispatch(
        dispatch(actions.updateAuditFormListStatus(formId, 4))
      ).then(() => {
        window.location.reload();
        dispatch(actions.updateFormStatus(api, name, formId, 4));
        dispatch(actions.fetchObject(api, name, formId));
      }).catch((error) => {
        // نمایش خطای سرور
        ShowToast("خطایی در تغییر وضعیت فرم رخ داد.", ToastType.error);
      });
    } else {
      // نمایش پیام خطا اگر رکوردی برای ویرایش وجود نداشت
      ShowToast("اطلاعات فرم برای ویرایش پیدا نشد.", ToastType.warning);
    }
  };
  const handleDeleteForm = () => {
    if (listState.objectForEdit && listState.objectForEdit.id) {
      const formId = listState.objectForEdit.id;

      // نمایش یک پیام تأیید قبل از حذف
      if (window.confirm("آیا مطمئن هستید که می‌خواهید این فرم را حذف کنید؟")) {
        // ارسال درخواست به سرور برای حذف فرم
        dispatch(
          actions.deleteObject("api/AuditFormList", name, formId, true) // softDelete = true
        ).then(() => {
          // بازگشت به صفحه لیست فرم‌ها
          history.push(basePath);
        }).catch((error) => {
          // نمایش خطای سرور
          ShowToast("خطایی در حذف فرم رخ داد.", ToastType.error);
        });
      }
    } else {
      // نمایش پیام خطا اگر رکوردی برای حذف وجود نداشت
      ShowToast("اطلاعات فرم برای حذف پیدا نشد.", ToastType.warning);
    }
  };

  const defaultSorted = [{ dataField: "id", order: "asc" }];
  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "30", value: 30 },
    { text: "50", value: 50 },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {intl.formatMessage({ id: "SHOW" })} {from}{" "}
      {intl.formatMessage({ id: "TO" })} {to} {intl.formatMessage({ id: "OF" })}{" "}
      {size} {intl.formatMessage({ id: "RESULT" })}
    </span>
  );
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: localQuery.pageSize,
    page: localQuery.pageNumber,
    paginationTotalRenderer: customTotal,
  };

  return (
    <FilterObjectsUIProvider>
      <ObjectsUIProvider ObjectsUIEvents={ObjectsUIEvents}>
        <ObjectsLoadingDialog listLoading={currentState.listLoading} />
        <Card>
          {listLoading && <ModalProgressBar />}
          <CardHeader>
            <div>
              <div className=" mb-2">{title1}</div>
              <div className=" mb-2">{title2}</div>
              <div className=" mb-2">{title3}</div>
            </div>
            <CardHeaderToolbar>
              {isSeatForm && <button
                type="button"
                className="btn btn-success mr-2"
                onClick={() => setShowGolestanSearch(true)}
                disabled={!isFullAccess}
              >
                {"جستجو در سیستم گلستان"}
              </button>}
              {`  `}
              <button
                type="button"
                className="btn btn-info"
                onClick={handleClickExport}
              // disabled={!isFullAccess}
              >
                <span>
                  {"   "}
                  {"خروجی اکسل"}
                  {"   "}
                </span>
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="mt-5">
              <AuditFormResultDialog
                show={show}
                id={selectedId}
                onHide={() => {
                  setShow(false);
                }}
                currentState={currentState}
                api={api}
              />

              {
                <GolestanSearchDialog
                  id={id}
                  show={showGolestanSearch}
                  onHide={() => {
                    setShowGolestanSearch(false);
                  }}
                  formListState={listState}
                  formResultState={currentState}
                  api={api}
                  methodName={methodName}
                  localQuery={localQuery}
                />}
              {/* 
                            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                                {({ paginationProps, paginationTableProps }) => {
                                    return (
                                        <Pagination
                                            isLoading={listLoading}
                                            paginationProps={paginationProps}
                                        > */}
              <BootstrapTable
                rowStyle={{ fontSize: 12 }}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                rowClasses={rowFormatter}
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={defaultSorted}
                onTableChange={getHandlerTableChange(setLocalQuery)}
              // selectRow={getSelectRow({
              //     entities,
              //     ids: objectsUIProps.ids,
              //     setIds: objectsUIProps.setIds,
              //     // hideSelected: hideSelected,
              //     // nonSelectableIds: checkActive ? entities && entities.filter(q => q.status !== "Enable").map(q => q.id) : []
              // })}
              // {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
              {/* </Pagination>
                                    );
                                }}
                            </PaginationProvider> */}
            </div>
          </CardBody>
        </Card>
        <CardFooter>
          <CardHeaderToolbar>
            {listState.objectForEdit &&
              listState.objectForEdit.status !== "Completed" && (
                <>
                  {" "}
                  <input type="checkbox" style={{ display: "none" }} />
                  <label className="checkbox checkbox-single mb-4">
                    <input
                      type="checkbox"
                      // checked={field.value}
                      onChange={(e) => {
                        setConfirm(e.target.checked);
                      }}
                    />
                    <span className="mr-4 " />
                    <b>
                      چنانچه پاسخ های ثبت شده مورد تایید شماست این گزینه را تیک
                      بزنید تا امکان تایید نهایی تکمیل پرسشنامه برای شما فعال
                      شود.
                    </b>
                  </label>
                </>
              )}

            {confirmForm && (
              <button
                type="submit"
                className="btn btn-success float-right mr-4 ml-4"
                onClick={saveObjectClick}
                disabled={
                  !isFullAccess ||
                  !listState.objectForEdit ||
                  listState.objectForEdit.status === "Completed"
                }
              >
                <i className="fa fa-check"></i>
                {"تایید نهایی تکمیل پرسشنامه"}
              </button>
            )}
            <button
              type="button"
              onClick={backToObjectsList}
              className="btn btn-light float-right  ml-4"
            >
              <i className="fa fa-arrow-left"></i>
              {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONBACK" })}
            </button>

            {confirmForm &&
              listState.objectForEdit &&
              listState.objectForEdit.status !== "Completed" && (
                <span className={`text-success`}>
                  توجه داشته باشید که پاسخ های شما تا زمانی که تمام پرسش ها را
                  تکمیل نکرده و دکمه تایید نهایی تکمیل پرسشنامه را نزنید به صورت
                  تایید نشده و به منزله تکمیل نشده خواهد بود
                </span>
              )}
            {confirmForm &&
              listState.objectForEdit &&
              listState.objectForEdit.status !== "Completed" && (
                <span className={`text-success`}>
                  . ضمنا توجه داشته باشید هرگاه برای فرم دکمه تایید نهایی تکمیل
                  پرسشنامه را کلیک نمایید دیگر قادر به تغییر پاسخ های خود
                  نیستید.
                </span>
              )}
            {listState.objectForEdit &&
              (listState.objectForEdit.status === "Completed" ||
                listState.objectForEdit.status !== "Completed") && (
                <div>
                  <span className="text-success">
                    پرسشنامه قبلا توسط شما تکمیل و تایید شده است.
                  </span>
                  <button
                    type="button"
                    className="btn btn-warning float-right ml-4"
                    onClick={() => handleEnableEditForm()}
                  >
                    فعال‌سازی ویرایش فرم
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger float-right ml-4"
                    onClick={() => handleDeleteForm()}
                  >
                    حذف فرم
                  </button>
                </div>
              )}


          </CardHeaderToolbar>
        </CardFooter>
      </ObjectsUIProvider>
    </FilterObjectsUIProvider>
  );
}
